// LoginForm.js
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, TextField, Typography } from '@mui/material';
import { AuthContext } from '../AuthContextProvider';
import ErrorDialog from '../ErrorDialog';
import * as Constants from '../Constants';
import { fetchWithTimeout } from '../utils/RpcUtils';
import '../App.css';

const LoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const { login, setLoginRole } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    // prevent default form submission reload
    if (e) e.preventDefault();

    try {
      const creds = new URLSearchParams();
      creds.append('login', username);
      creds.append('password', password);
      const response = await fetchWithTimeout('/itvs-site/login', {
        method: 'post',
        headers: {
          'Accept': 'application/json',
        },
        body: creds,
      });
      const user = await response.json();
      if (user.error) {
        setErrorMessage(user.error.message);
        setOpenErrorDialog(true);
      } else {
        login(user);
        if (user.roles.length > 1) {
          if (user.roles.length === 2) {
            if (user.roles[0] === Constants.ROLE_COMMUNITY_MEMBER) {
              setLoginRole(user, user.roles[1]);
              navigate('/home');
            } else if (user.roles[1] === Constants.ROLE_COMMUNITY_MEMBER) {
              setLoginRole(user, user.roles[0]);
              navigate('/home');
            } else {
              navigate('/setRole');
            }
          } else {
            navigate('/setRole');
          }
        } else if (user.roles.length === 1) {
          setLoginRole(user, user.roles[0]);
          navigate('/home');
        } else {
          throw new Error('User has no roles');
        }
      }
    } catch (err) {
      console.error(err);
      setErrorMessage(`failed to login ${err}`);
      setOpenErrorDialog(true);
    }
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  return (
    <form className="LoginForm" onSubmit={handleLogin}>
      <Typography variant="h6" gutterBottom>
        Login
      </Typography>
      <TextField
        className="TextField"
        label="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        margin="normal"
        fullWidth
      />
      <TextField
        className="TextField"
        type="password"
        label="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        margin="normal"
        fullWidth
      />
      <Button
        className="Button"
        variant="contained"
        color="primary"
        type="submit"
      >
        Login
      </Button>
      <ErrorDialog
        open={openErrorDialog}
        onErrorDialogClose={handleClose}
        errorMessage={errorMessage}
      />
    </form>
  );
};

export default LoginForm;
